import { css } from 'styled-components/macro';
import theme from '../../theme';

export const textStyle = css`
  color: ${theme.color.text.default};
`;
